import React, { useEffect, useState } from "react";
import "./style.css";
import volunteer from "../../Vectors/volunteer.png";
import { Spin, Alert } from "antd";
import { useTranslation } from "../../i18n/LanguageContext";
import API_URL from "../../apiBase";

const Volunteers = () => {
    const { t } = useTranslation();
    const [topUsers, setTopUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            try {
                const res = await fetch(`${API_URL}/api/users/top`, {
                    signal: controller.signal,
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                setTopUsers(data.users || []);
            } catch (err) {
                if (err.name !== "AbortError") {
                    setError(true);
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => controller.abort();
    }, []);

    return (
        <div className="main-content-wrapper">
            <div className="volunteers">
                <h2>{t("volunteers.title")}</h2>
                <p>{t("volunteers.intro")}</p>
                <h3>{t("volunteers.progress.title")}</h3>
                <p>{t("volunteers.progress.text")}</p>
                <h3>{t("volunteers.top.title")}</h3>
                <p>{t("volunteers.top.text")}</p>

                {loading ? (
                    <div className="topVolunteers__state">
                        <Spin size="large" />
                    </div>
                ) : error ? (
                    <Alert
                        type="error"
                        showIcon
                        message={t("volunteers.error")}
                        className="topVolunteers__alert"
                    />
                ) : topUsers.length === 0 ? (
                    <div className="topVolunteers__state">
                        <p>{t("volunteers.empty")}</p>
                    </div>
                ) : (
                    <div className="topVolunteers">
                        {topUsers.map((user, index) => (
                            <div key={user._id || index}>
                                <span className="rank">#{index + 1}</span>
                                <img
                                    src={user.avatar || volunteer}
                                    alt={user.name}
                                />
                                <span className="topVolunteers__name">
                                    {user.name}
                                </span>
                                <p>
                                    {t("volunteers.coins")} {user.points}
                                </p>
                            </div>
                        ))}
                    </div>
                )}

                <a href="/#app" className="joinBtn">
                    {t("volunteers.cta")}
                </a>
            </div>
        </div>
    );
};

export default Volunteers;
